// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/* CSS */
import "@css/app.pcss";

/* JS */
import 'lazysizes';
import { gsap } from "gsap";    
import { CustomEase } from "gsap/CustomEase";
import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";    
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { TextPlugin } from "gsap/TextPlugin";
/* The following plugins are Club GSAP perks */
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";
import iframeResize from '@iframe-resizer/parent';
//import * as YTPlayer from 'yt-player';


/* SCRIPTS HERE */


/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';

var duration = duration || 1;
gsap.registerPlugin(Flip,ScrollTrigger,ScrollToPlugin,Draggable,MotionPathPlugin,TextPlugin,DrawSVGPlugin,ScrambleTextPlugin,SplitText,RoughEase,ExpoScaleEase,SlowMo,CustomEase);


// Speedbump functions
var whitelistpatterns = [{"linkurl": '^[/|#].+', "exactmatch": 0}, {"linkurl":'^mailto:', "exactmatch": 0}, {"linkurl": '^tel:', "exactmatch": 0}, {"linkurl": '^javascript', "exactmatch": 0}];

function setWhiteListLinks() {
  //console.log(whitelistpatterns);
  const linkList = document.querySelectorAll("a");
  		
  for (let linkItem in linkList) {
    var url = linkList[linkItem].getAttribute('href');		
    var hasMatch = false;
    for (var wlLoop = 0; wlLoop < whitelistpatterns.length; wlLoop++) {
      if (whitelistpatterns[wlLoop].exactmatch) {
        //exact match url
        if (!hasMatch) {
          if (url == whitelistpatterns[wlLoop].linkurl) {
            linkList[linkItem].classList.add('local');
            hasMatch = true;
          }
        } 
        
      } else {
        //pattern match url					
        var testRegExp = new RegExp(whitelistpatterns[wlLoop].linkurl);				
        if (!hasMatch) {
          if( testRegExp.test(url)){ 						
            linkList[linkItem].classList.add('local');
            hasMatch = true;
          }
        }
        
      }			 				
    }
    if (!hasMatch) {      
      if(url.length > 1)
      {
        linkList[linkItem].classList.add('external');
        linkList[linkItem].addEventListener('click', function(e) {
          e.preventDefault();
          var attribute = this.getAttribute("href");
          var speedbumpStore = Alpine.store('speedbumpModal');
          speedbumpStore.open(attribute);
          
        }, false);					
      }
    }
  }  
}



document.addEventListener('alpine:init', () => {  
  
  const options = {
    license: 'GPLv3',
    log: 'collapsed',
    waitForLoad: true,
  };
  
  const iframeSelector = '.iframe-calc';
  
  iframeResize(options, iframeSelector);

  
  Alpine.store('contentModal', {
    on: false,
    modalHtml: '',
    showLoading: false,   
  
    open(modalUrl, modalTitle) {      
      this.modalHtml='loading...'; 
      this.showLoading = true; 
      this.on = true;
            
      fetch(modalUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
      .then(response => response.text())
      .then(text => {
        this.modalHtml = text
        this.showLoading = false;			   
      })
      
    },
    
    close() {
      this.on = false;
      this.modalHtml = '';
      this.showLoading = false;   
    }
  });
  
  Alpine.store('searchModal', {
    on: false,
  
    toggle() {
      this.on = !this.on;
      if (!this.on) {
        focus('focusEl');
      }
    },
      
    close() {
      this.on = false;
      focus('focusEl');   
    }
  });
  
  Alpine.store('loginModal', {
    on: false,
  
    toggle() {
      this.on = !this.on;
      if (!this.on) {
        focus('login_btn');
      }
    },
    
    close() {
      this.on = false;
      focus('login_btn');   
    } 
    
  });
  
  Alpine.store('speedbumpModal', {
    on: false,
    destination: '',
  
    open(attribute) {
      this.destination = attribute;
      this.on = true;      
    },
    
    close() {
      this.on = false;
      focus('focusEl');   
    }
  });
  
  // Speedbump setup
  const whitelistSource = '/resources/speedbumpwhitelist';  
  fetch(whitelistSource)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json(); 
    })
    .then(data => {
      console.log('Data received:', data);
      // Process the JSON data here
      for (var domainitem in data) {
        var myRegExp = "^(http|https)://";
        var itemText = data[domainitem].linkurl;
        if (itemText.startsWith("https://")) {
          itemText = itemText.slice(8);
        }
        if (itemText.startsWith("http://")) {
          itemText = itemText.slice(7);
        }
        if (itemText.endsWith("/")) {
          itemText = itemText.slice(0,-1);
        }
        myRegExp += itemText;
        if (data[domainitem].exactmatch) {
          whitelistpatterns.push({"linkurl": data[domainitem].linkurl, "exactmatch": data[domainitem].exactmatch});
        } else {				
          whitelistpatterns.push({"linkurl": myRegExp, "exactmatch": data[domainitem].exactmatch});
        }
      }
      setWhiteListLinks();
    })
    .catch(error => {
      console.error('Fetch error:', error);
    });
  
  Alpine.data('sectionStandard', (animateContent, staggerAnimations) => ({
    init() {       
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          y: 50
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1.5,		
              y: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.15			
            }),
            start: "top 90%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, { 			
              duration: duration * 1.5,
              y: 50,			
              opacity: 0,              			
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete: this.postRevealFunction,              	
              scrollTrigger: {
                trigger: animParent,
                start: "top 90%",
              }			
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1.5,
          y: 50,          
          opacity: 0,			
          // Note: Easing Pack required for easing
          ease: "expo.out",
          onComplete: this.postReveal,          			
          scrollTrigger: {
            trigger: animElem,
            start: "top 90%",
          }
        })  
      }           
    },
        
    postReveal() {
      
    }    
      
  })),
  
  Alpine.data('sectionSidePhoto', (animateContent, staggerAnimations) => ({
  init() {
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          y: 50
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1.5,		
              y: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.15			
            }),
            start: "top 95%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, { 			
              duration: duration * 1.5,
              y: 50,			
              opacity: 0,              			
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete: this.postRevealFunction,              	
              scrollTrigger: {
                trigger: animParent,
                start: "top 90%",
              }			
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1.5,
          y: 50,          
          opacity: 0,			
          // Note: Easing Pack required for easing
          ease: "expo.out",
          onComplete: this.postReveal,          			
          scrollTrigger: {
            trigger: animElem,
            start: "top 90%",
          }
        })  
      }                
    },
          
    postReveal() {
        
    }    
        
  }))
    
})

if (typeof window.Alpine === "undefined") {
  Alpine.plugin(collapse);
  Alpine.plugin(focus);
  Alpine.plugin(persist);
  window.Alpine = Alpine;
  window.Swiper = Swiper;  
  Alpine.start();
}


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
	console.log("HMR")
  });
}

